import { GraphQLClient } from 'graphql-request';
import { GRAPHQL_URI, DEFAULT_PRICE_MODEL, DEFAULT_SITE_ID } from '@config/constants';
import { SiteConfig } from '@utils';

export const createGraphQLClient = (signal?: AbortSignal | null | undefined) => {
  const { pricingDeterminationModel, locale, siteId } = SiteConfig.getConfig();
  return new GraphQLClient(GRAPHQL_URI!, {
    headers: () => ({
      'x-viax-user-locale': locale || '',
      'x-viax-user-website': siteId || DEFAULT_SITE_ID,
      'x-viax-user-pricing-model': pricingDeterminationModel || DEFAULT_PRICE_MODEL,
    }),
    signal,
  });
};

const getClient = (() => {
  let instance: GraphQLClient | null = null;
  return () => {
    if (!instance) {
      instance = createGraphQLClient();
    }
    return instance;
  };
})();

export { getClient };

export const client = new Proxy({} as GraphQLClient, {
  get(_target, prop) {
    return getClient()[prop as keyof GraphQLClient];
  },
});
